import { AxiosHttpGet, AxiosHttpPost } from 'axios-http';
import { SPARE_PARTS } from 'resources/links';

export function getHistory(serialNumberEquip : string) {
    return AxiosHttpGet({ url: SPARE_PARTS.getHistory, data: {serialNumberEquip} });
}